export default __webpack_public_path__ + "static/media/step-bg.290eecf9.png";